import type React from "react"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router"

import { AuthenticatedPageLayout } from "@/components/authenticated-page-layout"

export const ReportsLayoutRoute: React.FC = () => {
  const { t } = useTranslation("common")

  return (
    <AuthenticatedPageLayout
      title={t("moduleTitle.analyze")}
      wrapInPage={false}
    >
      <Outlet />
    </AuthenticatedPageLayout>
  )
}
